import useConfig from "@lib/use_config";
import useContent from "@lib/use_content";
import { useState } from "react";
import { useRouter } from "next/router";
import Session from "@lib/session";
import logoutProfile from "@lib/services/logout_profile";
import PulseLoader from "@hudson/ui/components/Loader/PulseLoader";
import classNames from "classnames";
import regexifyString from "regexify-string";
import FrameConfig from "@lib/classes/FrameConfig";

function LogoutGroup({}): JSX.Element | null {
  const router = useRouter();
  const { data, loading } = useContent(["beGroupLogoutLabel", "groupName", "charterName"]);
  const { data: configData, loading: configLoading } = useConfig(["lockGroupProfile"]);
  const [loggingOut, setLoggingOut] = useState(false);

  if (!Session.getBooking().profiles.group && !Session.getBooking().profiles.charter) return null;

  const charterLoggedIn = Session.getBooking().profiles.charter;

  let logoutGroupLabel = regexifyString({
    pattern: /_CODE_/gi,
    decorator: (match: string, index: number) => (
      <span key={index} className="font-extrabold" style={{ color: "var(--primary-color)" }}>
        {charterLoggedIn ? data?.content.charterName : data?.content.groupName}
      </span>
    ),
    input: data?.content.beGroupLogoutLabel,
  });

  async function logoutGroup() {
    setLoggingOut(true);
    await logoutProfile(charterLoggedIn ? "CHARTER" : "GROUP");
    await Session.clearSession();
    window.location.href = `${router.basePath}/${router.query.siteId}/book`;
  }

  if (
    !charterLoggedIn &&
    (new FrameConfig().lockGroupProfile || configData?.config.lockGroupProfile)
  )
    return null;

  return loading || configLoading ? null : (
    <div className="flex items-center">
      <a
        href="#"
        className={classNames("hover:opacity-75", { "opacity-75": loggingOut })}
        onClick={logoutGroup}
      >
        {logoutGroupLabel}
      </a>
      {loggingOut && <PulseLoader size={1} className="pl-1" />}
    </div>
  );
}

export default LogoutGroup;
